import {getAlpha3CodeByAlpha2code} from 'platform/components';

import {isNil, trim} from 'ramda';
import {isNotNil} from 'ramda-adjunct';

import type {SellerResponseBody} from '@dms/api/core';
import {parseSellerPhoneNumber} from '@dms/shared';

import type {Nullish} from 'shared/web';

export function getSourcingSellerInitialValues(seller: SellerResponseBody | Nullish) {
  if (isNil(seller)) {
    return undefined;
  }

  const phone = seller.phone
    ?.split(',')
    .map(trim)
    .map((rawNumber) => parseSellerPhoneNumber(rawNumber, seller.country?.key))
    .find(isNotNil);
  const countryCode = phone?.country ? getAlpha3CodeByAlpha2code(phone.country) : undefined;

  return {
    name: seller.name,
    email: seller.email,
    phoneNumber:
      isNotNil(phone) && isNotNil(countryCode)
        ? {
            prefix: `+${phone.countryCallingCode}`,
            number: phone.nationalNumber,
            countryCode,
          }
        : null,
  };
}
